import {cx} from "@emotion/css";

import {ReactComponent as SvgBuilding} from "~/assets/svg/building.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBuildingIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgBuilding id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
